import { mount } from 'svelte'
import LaunchpadModal from '../../components/launchpad/LaunchpadModal.svelte'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('launchpad-modal-app')
  if (el) {
    mount(
      LaunchpadModal,
      {
        target: el,
      })
  }
})
